import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.scss'],
})
export class MemberComponent implements OnInit {
  isMobile: boolean = false;
  noPadding: boolean = false;
  innerHeight: number;

  constructor(private route: ActivatedRoute,
    private router: Router) {
    router.events.subscribe(
      params => {
        this.noPadding = this.router.url.indexOf('home') !== -1
      }
    );
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    this.innerHeight = isMobile ? window.innerHeight - 69 : 1100;
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }

  ngOnInit(): void {
    this.isMobile = (window.innerWidth < 768);
    this.innerHeight = this.isMobile ? window.innerHeight - 69 : 1100;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member.component.ts